import React  from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import {APP_TITLE} from '../constants/config';

import appletouchicon from '../assets/images/favicons/apple-touch-icon.png';
import favicon32 from '../assets/images/favicons/favicon-32x32.png';
import favicon16 from '../assets/images/favicons/favicon-16x16.png';
import manifest from '../assets/images/favicons/manifest.json';  // eslint-disable-line
import browserconfig from '../assets/images/favicons/browserconfig.xml';  // eslint-disable-line
import safari_pinned_tab from '../assets/images/favicons/safari-pinned-tab.svg';  // eslint-disable-line

class Wrap extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <main className="main">
                <Helmet>
                    <title>{APP_TITLE}</title>
                    <link rel="apple-touch-icon" sizes="180x180" href={appletouchicon} />
                    <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
                    <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
                    <link rel="manifest" href={manifest} />
                    <link rel="mask-icon" href={safari_pinned_tab} color="#8fc73e" />
                    <meta name="apple-mobile-web-app-title" content={APP_TITLE} />
                    <meta name="application-name" content={APP_TITLE} />
                    <meta name="msapplication-config" content={browserconfig} />
                    <meta name="theme-color" content="#8fc73e" />
                </Helmet>
                {this.props.children}
            </main>
        );
    }

}


Wrap.propTypes = {
    children: PropTypes.element.isRequired,
};

// Use connect to put them together
export default Wrap;



// WEBPACK FOOTER //
// ./src/components/Wrap.js